import React from "react";
import Add from "./Add";
import Edit from "./Edit";
import Overview from "./Overview";
import { PositionProvider } from "../../../context/PositionContext";
export const Foods = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddFood = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditFood = () => {
  return (
    
      
        <Edit />
      
    
  );
};
